export const GetAppStats = async () => {
    try {
        const response = await fetch('/api/app-stats'); // Replace with your actual API endpoint
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data; // Ensure your API returns an object with the needed properties
    } catch (error) {
        console.error('Error fetching app stats:', error);
        throw error; // Rethrow to handle it in the Dashboard component if needed
    }
};
export const GetDownloadsStats = async () => {
    // Implementation here
    return {
        totalDownloads: 23,
        totalUninstalls: 200,
        downloadsThisWeek: 6,
    };
};


